import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { AdminModel } from 'higgins-domain'

import { EntityRow } from '@salsita-ai/platform-project-sdk/admin'
import { GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'

import { adminInterface } from '../../systems/admin-interface'

export const SegmentPricesPage = () => {
  const segmentPrices = adminInterface.useRenderedSelector(e => {
    return [...e.state.entities.filter(ent => AdminModel.SegmentPrice.is(ent))].sort((a, b) =>
      a.product_code.localeCompare(b.product_code)
    )
  }, [])

  return (
    <Stack gap={2}>
      <TableContainer>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow>
              <TableCell>Product Code</TableCell>
              <TableCell sx={{ width: '12ch' }}>Width</TableCell>
              <TableCell sx={{ minWidth: '20ch' }}>Material Type</TableCell>
              <TableCell sx={{ width: '20ch' }}>Price</TableCell>
              <TableCell sx={{ width: 62 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {segmentPrices.map(sp => (
              <TableRow key={sp.id}>
                <TableCell>{sp.product_code}</TableCell>
                <TableCell>{sp.width}</TableCell>
                <TableCell>{sp.material_type}</TableCell>
                <TableCell>
                  <GenericDimensionInput entityId={sp.id} instanceName="price" />
                </TableCell>
                <TableCell />
              </TableRow>
            ))}
            {segmentPrices.length === 0 && <EntityRow.EmptyRow title="No segment prices found" span={5} />}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}
